/**
 * Event status values, as the server sends them.
 *
 * Lives in the engine because `isReadOnly` in form-helpers keys off it: a form
 * belonging to a Received, Scheduled or Missing event renders read-only — every
 * status except Active. It used to be imported from
 * `~/components/Events/event-status`, which the engine cannot do once it is a
 * standalone package.
 *
 * Deliberately a leaf: no imports, not even types. The engine's dependency
 * graph should bottom out at a frozen string map rather than reaching into an
 * event domain that would in turn drag in API types. (In the
 * Viedoc.Me.ReactNative POC this constant sat in an `events/` module that
 * imported `api/types`, which quietly made the whole form package
 * non-standalone.)
 *
 * `components/Events/event-status.js` re-exports this, so event-list and
 * dashboard code keeps its existing import path.
 */
export const EventStatus = Object.freeze({
    MISSING: "Missing",
    RECEIVED: "Received",
    SCHEDULED: "Scheduled",
    ACTIVE: "Active",
});
